import React, { useEffect, useState } from "react";
import { Row, Col, Container } from "react-bootstrap";
import Chart from "react-apexcharts";
import { Card, Select } from "antd";
import CryptoJS from "crypto-js";
import axios from "../services/axiosConfig";
import Helper from "../services/Helper";

const Dashboard = () => {
  let roleId = localStorage.getItem("items");
  var bytes = CryptoJS.AES.decrypt(
    roleId || 1,
    "J8Lw2Be[CdBZhf/!3?}973Z5O'uNtY4N"
  );
  var originalText = bytes.toString(CryptoJS.enc.Utf8);
  const [pageDetails, setPageDetails] = useState([]);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());

  useEffect(() => {
    try {
      (async () => {
        const details = await axios
          .get("/dashboard", {
            params: {
              data: originalText != "1" ? 345345 : "",
              year: selectedYear,
            },
          })
          .catch((error) => {
            Helper.ErrorHanlder(error);
          });
        if (details && details.data) {
          setPageDetails(details.data);
        }
      })();
    } catch (error) {
      Helper.ErrorHanlder(error);
    }
  }, [originalText, selectedYear]);

  const getYearOptions = () => {
    const currentYear = new Date().getFullYear();
    return Array.from({ length: 4 }, (_, i) => ({
      value: currentYear - i,
      label: currentYear - i,
    }));
  };

  return (
    <Container fluid>
      <div className="main-dashboard-pg">
        <Row>
          {originalText == 1 && (
            <Col lg={6} className="dashboard-cards">
              <Col md={6} xs={12}>
                <Card
                  title="Customers"
                  bordered={false}
                  className="cards-details"
                >
                  {pageDetails?.data?.totalCount}
                </Card>
              </Col>
              <Col md={6} xs={12}>
                <Card
                  title="Pending Amount"
                  bordered={false}
                  className="cards-details pending"
                >
                  {pageDetails?.data?.totalPendingAmount}
                </Card>
              </Col>
              <Col md={6} xs={12}>
                <Card
                  title="Pending Orders (Printing)"
                  bordered={false}
                  className="cards-details"
                >
                  {pageDetails?.orders?.pendingCount}
                </Card>
              </Col>
              <Col md={6} xs={12}>
                <Card
                  title="Ongoing Orders"
                  bordered={false}
                  className="cards-details"
                >
                  {pageDetails?.orders?.inProgressCount}
                </Card>
              </Col>
            </Col>
          )}
          <Col lg={originalText == 1 ? 6 : 12}>
            <Select
              value={selectedYear}
              style={{ marginBottom: "5px" }}
              onChange={setSelectedYear}
              options={getYearOptions()}
            />
            <div className="year-chart">
              <Chart
                options={{
                  chart: {
                    id: "candlestick",
                  },
                  xaxis: {
                    categories: [
                      "Jan",
                      "Feb",
                      "Mar",
                      "Apr",
                      "May",
                      "Jun",
                      "Jul",
                      "Aug",
                      "Sep",
                      "Oct",
                      "Nov",
                      "Dec",
                    ],
                  },
                }}
                series={[
                  {
                    name: "Orders",
                    data: pageDetails?.chartDetails,
                  },
                ]}
                type="bar"
                height={320}
              />
            </div>
          </Col>
          <Col lg={12}>
            <div className="year-chart">
              <Chart
                options={{
                  chart: {
                    type: "bar",
                    height: 350,
                  },
                  plotOptions: {
                    bar: {
                      borderRadius: 4,
                      horizontal: true,
                    },
                  },
                  dataLabels: {
                    enabled: false,
                  },
                  xaxis: {
                    categories: [
                      "Jan",
                      "Feb",
                      "Mar",
                      "Apr",
                      "May",
                      "Jun",
                      "Jul",
                      "Aug",
                      "Sep",
                      "Oct",
                      "Nov",
                      "Dec",
                    ],
                  },
                }}
                series={[
                  {
                    name: "Amount",
                    data: pageDetails?.profitDetails,
                  },
                ]}
                type="bar"
                height={320}
              />
            </div>
          </Col>
        </Row>
      </div>
    </Container>
  );
};

export default Dashboard;
